<template lang="pug">
  aside.fb-login-modal
    .fb-login-modal__close(@click='closeModal')
    h6.fb-login-modal__title ログインしてフォローする
    .fb-login-modal__desc 企業をフォローすると新着のプレスリリース情報をメールと管理画面から受け取ることができます。
    .fb-login-modal__btn-area
      .fb-login-modal__btn-desc-wrap
        p.fb-login-modal__btn-desc
          span.fb-login-modal__btn-desc-icon
            img.fb-login-modal__btn-desc-icon-img(src='/common/v4.1/images/html_m/svg/icon-login-media.svg' alt='受信 メディア・個人のお客様')
          span.fb-login-modal__btn-desc-text-main 受信
          span.fb-login-modal__btn-desc-text-sub メディア・個人のお客様
        .fb-login-modal__btn-desc-balloon-wrap(:class="{'is-pc':!mobile}" ref="media")
          span.fb-login-modal__btn-desc-balloon-question
            span.fb-login-modal__btn-desc-balloon-question-inner(@touchstart="balloonOpen('media')" @touchend="balloonClose('media')") ?
          span.fb-login-modal__btn-desc-balloon ユーザー登録でプレスリリースの受信や保存機能が利用可能です。メディアユーザーは限定情報を閲覧できます。
      a.fb-login-modal__btn--media(@click='addCookieBeforeLeaveForMediaUser') メディアユーザーでログインする
      a.fb-login-modal__btn--social(@click='addCookieBeforeLeaveForSocialUser') 個人ユーザーでログインする
      .fb-login-modal__register-text 新規登録：
        br.fb-login-modal__register-new-line
        a.fb-login-modal__register-link(href='/main/registmedia/social') 個人ユーザー
        | ｜
        a.fb-login-modal__register-link(href='/main/registmedia/form') メディアユーザー
</template>
<script>
import { toggleCookieFromFaceBook } from './../../cookies/cookies';
import { throttle } from 'throttle-debounce'; // https://www.npmjs.com/package/throttle-debounce
import isMobile from 'ismobilejs'; // https://www.npmjs.com/package/ismobilejs

export default {
  name: 'FacebookLogin',
  mounted: function () {
    this.setPosition();
    window.addEventListener('resize', throttle(300, this.setPosition));
  },
  computed: {
    mobile () {
      return isMobile(window.navigator).any;
    }
  },
  methods: {
    addCookieBeforeLeaveForMediaUser: function (e) {
      toggleCookieFromFaceBook(true);
      window.location.href = `/main/html/medialogin?back_uri=${window.location.pathname}${window.location.search}`;
      e.preventDefault();
    },
    addCookieBeforeLeaveForSocialUser: function (e) {
      toggleCookieFromFaceBook(true);
      window.location.href = `/main/html/sociallogin?back_uri=${window.location.pathname}${window.location.search}`;
      e.preventDefault();
    },
    closeModal: function () {
      this.$emit('closeModal');
    },
    setPosition: function () {
      const adjustedHeight = window.innerHeight;
      document.querySelector('.modal-component__overlay').style.height = `${adjustedHeight}px`;
    },
    balloonOpen: function (ref) {
      this.$refs[ref].classList.add('is-touched');
    },
    balloonClose: function (ref) {
      this.$refs[ref].classList.remove('is-touched');
    }
  }
};
</script>
